import { render } from "./Create.vue?vue&type=template&id=40bdcbf6"
import script from "./Create.vue?vue&type=script&lang=js"
export * from "./Create.vue?vue&type=script&lang=js"

import exportComponent from "/Users/hamidrezabanihashemi/Documents/laptap_dell/Sites/goshe_shenava/gosheshenava_front/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__